import Attribute from '@/models/Attribute'
import Descriptor from '@/models/Descriptor'
import Effect from '@/models/Effect'
import Item from '@/models/Item'
import Resource from '@/models/Resource'
import Skill from '@/models/Skill'
import Spell from '@/models/Spell'
import Trait from '@/models/Trait'

export default {
  Attribute,
  Descriptor,
  Effect,
  Item,
  Resource,
  Skill,
  Spell,
  Trait,
}
